// extracted by mini-css-extract-plugin
module.exports = {"desktopS2LayoutColumnsWrapper":"desktop-s2-layout_desktopS2LayoutColumnsWrapper__uOEJF","left":"desktop-s2-layout_left__5CiNJ","right":"desktop-s2-layout_right__0dsK1"};